import { ReactNode } from 'react';
import { Input } from '../ui/input';
import { cn } from '../../utils/helpers';

interface FilterBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  children?: ReactNode;
  className?: string;
  resultCount?: {
    filtered: number;
    total: number;
  };
}

export function FilterBar({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Search...',
  children,
  className,
  resultCount,
}: FilterBarProps) {
  return (
    <div className={cn('flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-4', className)}>
      <Input
        placeholder={searchPlaceholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-full sm:w-80"
      />
      {children}
      {resultCount && (
        <div className="text-sm text-muted-foreground whitespace-nowrap">
          {resultCount.filtered} of {resultCount.total} items
        </div>
      )}
    </div>
  );
}
